import { Observable, of } from "rxjs";

import { ProductVariantIdProviderInterface } from "./ProductVariantIdProviderInterface";

export class ProductVariantIdFromStaticProvider
    implements ProductVariantIdProviderInterface
{
    constructor(private readonly _variantId: number) {}

    selectVariantId(): Observable<number | null> {
        return of(this._variantId);
    }
}
